'use strict';

module.exports = Number.isFinite || function (value) {
  return !(typeof value !== 'number' || value !== value || value === Infinity || value === -Infinity);
};